import React from "react";
import { FaLaptopCode } from "react-icons/fa";
import { FaMobileAlt } from "react-icons/fa";
import { GrOptimize } from "react-icons/gr";
import { FaCode } from "react-icons/fa";
import "./about.css";
const testimonials = [
  {
    name: "Pulak Kundu",
    image: "./assets/images/Pulak.png",
    text: `Harsh I worked in the same team for a project for 6 months. He is a very fast learner. Being an intern, he was able to understand project objectives and learned the required skills very quickly. He contributed to both frontend and backend parts of the project.
    He possesses very good presentation and communication skills. He also has a very positive attitude towards his work.
    Harsh will be an asset to any team and I wish him all the very best.`,
    profileLink: "https://www.linkedin.com/in/pulak-kundu-01142625/",
  },
  {
    name: "Aditya Arun",
    image: "./assets/images/Aditya.png",
    text: `Harsh worked with me as an intern for 2 months. He came fresh from college and was given a pretty technical, networking domain-specific data science project as his goal. What he achieved in those two months was much more than what I had expected.
    We gave him the basics of the domain, some papers on what we wanted to achieve, and unleashed him on our data. He was self-motivated and inquisitive, figuring out most of the stuff on his own. He analyzed our dataset and recommended what algorithms and data points made sense.
    I found him proficient in Python and data science-related technologies. He is very dedicated and has the tenacity to push through challenges.
    I am very happy with his work, and even though our association was short, his work will influence our design and products for some time. I wish him the best in his future endeavors.`,
    profileLink: "https://www.linkedin.com/in/aditya-arun/",
  },
  {
    name: "Puneeth Uchil",
    image: "./assets/images/Puneeth.webp",
    text: "Harsh is one of the most energetic, fast-learning, and focused interns I worked with. His work during the internship with Licious is commendable. He carries a great attitude. His dedication to his work is exemplary.",
    profileLink: "https://www.linkedin.com/in/puneeth-uchil-2004a619/",
  },
  {
    name: "Garima Garg",
    image: "./assets/images/Garima.webp",
    text: "Harsh has been a valuable asset to The Thapar Institute Counselling Cell and I am sure he will add value to any organization he becomes a part of. As a team vice lead, he was organized as well as helpful and was always open to new ideas and suggestions. I would recommend him for his managerial skills, dedication, and good humor.",
    profileLink: "https://www.linkedin.com/in/garima-garg-777488189/",
  },
  {
    name: "Prateek Bansal",
    image: "./assets/images/Prateek.png",
    text: "Harsh and I joined Thapar University in 2019 together. Since then, we have worked on multiple projects and in the same teams many times. He has immense talent and uses it in a disciplined manner consistently. His dedication, patience, and leadership skills make him one of the best team members to work with. Truly a great engineer.",
    profileLink: "https://www.linkedin.com/in/itsprateekbansal/",
  },
  {
    name: "Madhav Arora",
    image: "./assets/images/Madhav.webp",
    text: `As a leader, Harsh exemplified strong leadership qualities, demonstrating exceptional communication, motivational, and organizational skills. He expertly managed our team, ensuring that everyone was aligned with the goals and objectives of the organization.
    Under Harsh's leadership, our team achieved great heights. His strategic thinking, decision-making, and ability to execute plans were exceptional. He created a positive and inclusive team culture that fostered collaboration, innovation, and excellence.
    I highly recommend Harsh for any leadership or managerial role. He is a talented leader who inspires and empowers his team to achieve remarkable results.`,
    profileLink: "https://www.linkedin.com/in/webmadaro/",
  },
];
export default function About() {
  
  return (
    <>
      <div className="infocontent">
        <p>
         
        I am a highly skilled and motivated Software Engineer with a strong background in Computer Science. I completed my education at Thapar Institute of Engineering and Technology, where I graduated with a remarkable CGPA of 9.71. Throughout my academic journey, I developed a comprehensive understanding of software development principles, which I have further refined through my professional experiences with renowned companies such as Apple, Paypal, Licious, Cisco, Tata 1mg, and Yash Technologies.
                  
        </p>
        <p>
         
        I am a highly skilled and motivated Software Engineer with a strong background in Computer Science. I completed my education at Thapar Institute of Engineering and Technology, where I graduated with a remarkable CGPA of 9.71. Throughout my academic journey, I developed a comprehensive understanding of software development principles, which I have further refined through my professional experiences with renowned companies such as Apple, Paypal, Licious, Cisco, Tata 1mg, and Yash Technologies.
                  
        </p>
        <p>
        
        I am a highly skilled and motivated Software Engineer with a strong background in Computer Science. I completed my education at Thapar Institute of Engineering and Technology, where I graduated with a remarkable CGPA of 9.71. Throughout my academic journey, I developed a comprehensive understanding of software development principles, which I have further refined through my professional experiences with renowned companies such as Apple, Paypal, Licious, Cisco, Tata 1mg, and Yash Technologies.
                  
        </p>
      </div>
      <section className="interest">
        <div className="container">
        <h3 className="h3 clients-title">My Interests</h3>

          <div className="service-list">
            <div className="interest-container">
              <FaLaptopCode
                className="icons3"
                style={{ color: "hsl(45, 100%, 72%)" }}
              />
              <div className="text-interest">
                <h4 className="h4 service-item-title">Web Development</h4>
                <p className="service-item-text">
                  Built websites during my internship using HTML, CSS, React JS,
                  Gatsby and Angular.
                </p>
              </div>
            </div>
            <div className="interest-container">
              <FaMobileAlt
                className="icons3"
                style={{ color: "hsl(45, 100%, 72%)" }}
              />
              <div className="text-interest">
                <h4 className="h4 service-item-title">Mobile Development</h4>
                <p className="service-item-text">
                  Built websites during my internship using Angular-Ionic for
                  both android and ios users.
                </p>
              </div>
            </div>
            <div className="interest-container">
            <FaCode                 className="icons3"
                style={{ color: "hsl(45, 100%, 72%)" }}
              />              <div className="text-interest">
                <h4 className="h4 service-item-title">Machine Learning</h4>
                <p className="service-item-text">
                  Built model for Hindi Sentimental Analysis to compare
                  accuracy, precision call of models.
                </p>
              </div>
            </div>
            <div className="interest-container">
              <GrOptimize
                className="icons3"
                style={{ color: "hsl(45, 100%, 72%)" }}
              />
              <div className="text-interest">
                <h4 className="h4 service-item-title">SEO Optimization</h4>
                <p className="service-item-text">
                  Reduced loading time of website , increased user experinece,
                  implemented CDN for better performance.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="testimonials">
        <h3 className="h3 testimonials-title">Recommendations</h3>
        <ul className="testimonials-list has-scrollbar">
          {testimonials.map((testimonial, index) => (
            <li className="testimonials-item" key={index}>
              <div className="content-card">
                <figure className="testimonials-avatar-box">
                  <img
                    src={testimonial.image}
                    alt={testimonial.name}
                    width="60"
                  />
                </figure>
                <h4 className="h4 testimonials-item-title">
                  {testimonial.name}
                </h4>
                <div className="testimonials-text">
                  <p>{testimonial.text}</p>
                  <br />
                  <a
                    href={testimonial.profileLink}
                    className="custom-link"
                    style={{
                      color: "hsl(45, 54%, 58%)",
                      textDecoration: "none",
                    }}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    View their profile
                  </a>
                </div>
              </div>
            </li>
          ))}
        </ul>
      </section>
      <section className="clients">
      <h3 className="h3 clients-title">Experiences</h3>
      <ul className="clients-list has-scrollbar">
        <li className="clients-item">
          <a href="https://www.apple.com/">
            <img src="https://images.wavel.ai/website/Homepage_Logo_Name.webp" alt="apple" />
          </a>
        </li>
        <li className="clients-item">
          <a href="https://www.paypal.com/">
            <br />
            <br />
            <br />
            <img
              src="https://images.wavel.ai/website/Homepage_Logo_Name.webp"
              width="paypal"
              height="120px"
              alt="client logo"
            />
          </a>
        </li>
        <li className="clients-item">
          <a href="https://www.cisco.com/">
            <img src="https://images.wavel.ai/website/Homepage_Logo_Name.webp" alt="cisco" />
          </a>
        </li>
        <li className="clients-item">
          <a href="https://www.1mg.com/">
            <br />
            <br />
            <img src="https://images.wavel.ai/website/Homepage_Logo_Name.webp" alt="cisco" />
          </a>
        </li>
        <li className="clients-item">
          <a href="https://www.licious.in/">
            <br />
            <img
              src="https://images.wavel.ai/website/Homepage_Logo_Name.webp"
              alt="licious"
              width="400px"
              height="200px"
            />
          </a>
        </li>
        
      </ul>
    </section>
  
    </>
  );
}
